<template>
  <GModal class="modal--combination">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img src="/assets/img/icons/back.svg" @click.prevent="close" />
      </button>

      <h2 class="modal-heading modal-heading__header">SELECT COMBINATION</h2>
    </div>

    <div slot="body">
      <div v-if="!screen.isDesktop" class="parent-progress">
        <span class="counter-progress">1 of 3</span>
        <div class="progress">
          <div class="progress-bar" style="width: 30%"></div>
        </div>
      </div>

      <div class="combination-head">
        <div class="product-display">
          <div class="product-display__thumb">
            <img class="product-image" :src="productImage" :alt="productSelected.name" />
          </div>

          <div class="product-display__content">
            <div class="product-header">
              <h5 v-if="productSelected.brand" class="brand-name">{{ productSelected.brand.name }}</h5>
              <img src="/assets/img/icon-shopper.svg" height="18" width="18" alt="shopper" class="icon-shop-expert" />
            </div>
            <p class="product-name">{{ convertName(productSelected.name) }}</p>
            <button href="" class="button-change-product" @click.prevent="openModal">Change Product</button>
          </div>
        </div>
        <h2 class="modal-heading-combination">Pilih varian dari produk yang akan kamu review</h2>
      </div>

      <div class="combination-body">
        <div class="choose-combination">
          <ul class="list-combination">
            <li v-for="(combinationGroup, key) in productSelected.list_combinations" :key="key + 'kjk'">
              <a
                href=""
                :class="{ disabled: combinationGroup.is_reviewed === true }"
                @click.prevent="combinationChange(key)"
              >
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-html="combinationGroup.name_html"></div>
                <div
                  v-if="combinationGroup.is_verified_purchase && !combinationGroup.is_reviewed"
                  class="trusted-review"
                >
                  <img
                    v-if="screen.isDesktop"
                    src="/assets/img/icon-shopper.svg"
                    height="18"
                    width="18"
                    alt="shopper"
                    class="icon-shop-expert"
                  />
                </div>
              </a>
              <div v-if="combinationGroup.is_reviewed === true" class="has-reviewed">
                <span class="red">Reviewed</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'modal-combination',
  data() {
    return {
      combinationKeyActive: 0,
      activeGroupName: '',
      isProcessingSubmit: false,
      productSelected: {},
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.userProfile;
    },
    currentCombination() {
      return this.productSelected.currentCombination;
    },
    screen() {
      return this.$store.state.screen;
    },
    productImage() {
      if (
        this.productSelected &&
        this.productSelected.list_combinations &&
        this.productSelected.list_combinations.length &&
        this.productSelected.list_combinations[this.combinationKeyActive].images &&
        this.productSelected.list_combinations[this.combinationKeyActive].images.length
      ) {
        return this.productSelected.list_combinations[this.combinationKeyActive].images[0].url;
      }
      return '/assets/img/dummy_product.svg';
    },
  },
  watch: {
    '$store.state.writeReview.selectedProduct': {
      handler(newVal) {
        if (newVal) {
          let combination = [];
          const list_combinations = newVal.list_combinations;

          if (list_combinations && list_combinations.length) {
            combination = list_combinations.filter((data) => data.is_active_in_review);
          }

          const updatedProduct = { ...newVal, list_combinations: combination };

          this.productSelected = updatedProduct;

          const isCombinationModalOpen = this.$store.state.modal.isModalShow.combination;
          const hasCombinationQuery = this.$route.query.combination_id !== undefined;

          if (combination.length < 2 && isCombinationModalOpen) {
            // Close modal if product has one combination or no combination
            this.$store.commit('toggleModalGlobalState', { modalName: 'combination' });
          } else if (combination.length >= 2 && (!isCombinationModalOpen || hasCombinationQuery)) {
            // Open modal if multiple combinations exist or combination_id is present
            this.$store.commit('toggleModalGlobalState', { modalName: 'combination' });
          }
        }
      },
      deep: true, // Ensures nested objects are watched
      immediate: true, // Runs handler immediately upon component initialization
    },
    currentCombination: {
      handler(val) {
        if (val.name) {
          const new_name = val.name;
          try {
            let result = '';
            // let result_cart = '';
            const new_array = new_name.split(',');

            if (new_array.length > 1) {
              const split_1 = new_array[0].split('-');
              const split_2 = new_array[1].split('-');
              const text_1_1 = split_1[0].replace(/(?:^|\s)\S/g, function (a) {
                return a.toUpperCase();
              });
              const text_1_2 = this.ucwordsAttributeName(split_1[1]);
              const text_2_1 = split_2[0].replace(/(?:^|\s)\S/g, function (a) {
                return a.toUpperCase();
              });
              const text_2_2 = this.ucwordsAttributeName(split_2[1]);

              result = `<b>${text_1_1}</b>: ${text_1_2}<br><b>${text_2_1}</b>: ${text_2_2}`;
              // result_cart = `${text_1_1}: ${text_1_2}, ${text_2_1}: ${text_2_2}`;
            } else {
              if (new_array.length == 1) {
                const split = new_array[0].split('-');
                const text_1 = split[0].replace(/(?:^|\s)\S/g, function (a) {
                  return a.toUpperCase();
                });
                const text_2 = this.ucwordsAttributeName(split[1]);

                result = `<b>${text_1}</b>: ${text_2}`;
                // result_cart = `${text_1}: ${text_2}`;
              }
            }

            this.activeGroupName = result;
          } catch (e) {
            this.activeGroupName = val.name;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    combinationChange(key) {
      const value = this.productSelected.list_combinations[key];
      this.combinationKeyActive = key;
      this.$store.commit('addKeyToSelectedProduct', {
        key: 'selected_combination',
        value: value,
      });
      this.close();
    },
    close() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'combination' });
    },
    openModal() {
      this.$store.dispatch('setModalSearchProduct', true);
    },
    convertName(title) {
      let name = title;
      if (typeof name == 'string') {
        const word_length = 40;
        if (name.toString().length >= word_length) {
          name = name.toString().substr(0, word_length) + '...';
        }
        return name;
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
.modal--combination {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;

  .disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  .product-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .brand-name {
    font: normal 14px/14px 'lato-bold', sans-serif;
    letter-spacing: normal;
    margin: 0 0 6px;
    padding: 0;
    display: block;
    text-transform: uppercase;
    color: #231f20;
  }

  .icon-shop-expert {
    margin-left: auto;
  }
  .combination-head {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 24px 24px 10px 24px;
  }

  .modal-heading,
  .modal-heading-combination {
    font: normal 16px/24px 'lato-bold', sans-serif;
    letter-spacing: 0;
    margin: 18px auto 0px auto;
    padding: 0;
    color: #231f20;
  }

  .list-combination {
    display: block;
    margin: 0px 25px 0px 25px;
    padding: 0;
    max-height: 300px;
    height: auto;
    overflow-y: auto;
    list-style: none;
    > li {
      display: block;
      margin: 0;
      padding: 12px 4px;
      list-style: none;
      width: 100%;
      position: relative;
      font: normal 14px/17px 'lato-regular';
      border-bottom: solid 1px #e5e5e5;
      color: #231f20;
      &.disabled {
        label {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
      > a {
        display: flex;
        margin: 0;
        color: #231f20;
        position: relative;
        z-index: 2;
        align-items: center;
      }
      label {
        font-weight: 400;
        // text-transform: capitalize;
      }
    }
  }

  .product-display {
    padding: 12px;
    width: 500px;
    background-color: #ffffff;
    border-radius: 4px;
    border: 0.5px solid #cccccc;
    &:before,
    &:after {
      content: ' ';
      display: table;
    }
    &:after {
      clear: both;
    }
  }

  .product-display__content {
    height: 100%;
    padding-left: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    gap: 10px;
  }

  .product-display__thumb {
    float: left;
    width: 100;
    height: 100px;
  }

  .product-image {
    display: block;
    width: 100px;
    height: 100px;
    object-fit: cover;
  }

  .product-name {
    font-family: 'lato-regular', sans-serif;
    font-size: 16px;
    line-height: 22px;
    margin: 0;
    padding: 0;
    display: block;
    color: #09000080;
  }
  .button-change-product {
    font-family: 'lato-bold', sans-serif;
    font-size: 12px;
    line-height: 22px;
    width: 33%;
    height: 50%;
    border: 1px solid #b32656;
    border-radius: 100px;
    padding: 4px 16px;
    color: #b32656;
    background-color: #ffffff;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.5;
    background-color: rgba(0, 0, 0, 0.24);
  }

  .modal-body {
    padding: 0;
  }

  .modal-header {
    display: none;
  }

  .modal-container {
    width: auto;
    height: auto;
    margin: 0 auto;
    background-color: #ffffff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    position: relative;
  }

  .modal-content {
    border: none;
  }

  .modal-dialog {
    width: 548px;
    border-radius: 8px;
  }

  .modal-header {
    padding: 16px 16px 8px 16px;
    border-bottom: none;
    min-height: auto;
  }

  .modal-footer {
    display: none;
  }

  .modal-dismiss {
    opacity: 0.5;
    top: 14px;
    right: 14px;
    max-width: 128px;
    margin-top: 0px;
    margin-bottom: 8px;
    font-size: 40px;
    letter-spacing: normal;
    height: 20px;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    margin: 0;
    outline: none;
    z-index: 11;
    opacity: 1;
  }

  .radio-donut {
    padding-left: 36px;
    > span {
      top: calc(50% - 10px);
      height: 20px;
      width: 20px;
      &:after {
        height: 8px;
        width: 8px;
      }
    }
  }

  .shade-img {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 50%;
    margin-right: 12px;
  }

  .trusted-review {
    position: absolute;
    right: 0;

    .trusted-review__text {
      font: 10px 'lato-bold', sans-serif;
      letter-spacing: 1px;
      color: #828282;
    }
    .trusted-review__icon {
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .has-reviewed {
    position: absolute;
    right: 10px;
    top: 20px;
    .red {
      right: 10px;
      top: 10px;
      font: 12px 'lato-bold', sans-serif;
      line-height: 14.4px;
      color: #eb395f;
    }
  }
}

@media (max-width: 991px) {
  .modal--combination {
    .list-combination {
      max-height: 197px;
    }
    .modal-body {
      height: 100%;
    }
  }
}

@media (max-width: 740px) {
  .modal--combination {
    .close {
      display: none;
    }

    .choose-combination {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .combination-body {
      overflow: auto;
    }

    .combination-head {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
    }

    .list-combination {
      height: calc(100vh - 300px);
      // max-height: none;
      max-height: 240px;
    }

    .modal {
      display: block !important;
    }

    .modal-container {
      width: 100%;
      border-radius: 0px;
      box-shadow: none;
      height: 100vh;
    }

    .modal-content {
      border-radius: 0;
      height: 100vh;
    }

    .modal-dialog {
      width: 100%;
      margin: 0;
      border-radius: 0;
    }

    .modal-header {
      display: block;
      padding: 18px 15px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
      .close {
        display: inline-block;
        position: static;
        float: none;
        > img {
          margin-right: 24px;
        }
      }
    }

    .modal-heading {
      width: 100%;
      margin: 0;
    }

    .modal-heading-combination {
      width: 100%;
      color: #231f20;
      padding: 15px 0px;
    }

    .container-head {
      background: url('/assets/img/bg-select-combination.svg') no-repeat;
      background-position: center;
      height: 60px;
    }

    .modal-heading__header {
      font: 14px/20px 'lato-bold', sans-serif;
      letter-spacing: normal;
      text-align: left;
      display: inline-block;
      margin: 0;
      width: auto;
    }

    .product-display {
      position: relative;
      bottom: -24px;
      z-index: 99;
      width: 100%;
      .button-change-product {
        width: 80%;
        height: auto;
      }
    }
  }
}
</style>
